import React, {useState} from "react";
import {Rate, Steps} from 'antd';
import styled from "styled-components";
import "./style.scss";
import {Form, Input, Button, Checkbox} from 'antd';
import {Select} from 'antd';
import {StarFilled} from "@ant-design/icons";
import {useHistory} from "react-router-dom";

const {Option} = Select;
const {Step} = Steps;

const Box = styled.div`
  padding: 16px;
  position: relative;
  box-shadow: rgb(0 0 0 / 8%) 0px 1px 3px 1px;
  border-radius: 0px;
  background-color: rgb(244, 248, 254);
  border: 1px solid rgb(221, 223, 226);
  margin-bottom: 20px;
`;

const BoxWhite = styled.div`
  padding: 16px;
  position: relative;
  box-shadow: rgb(0 0 0 / 5%) 0px 1px 3px 1px;
  border-radius: 0px;
  background-color: #fff;
  border: 1px solid rgb(232, 232, 232);
  margin-bottom: 20px;
`;

const BoxTitle = styled.h3`
  box-sizing: border-box;
  margin: 0px;
  flex-basis: 100%;
  -webkit-box-flex: 0;
  flex-grow: 0;
  max-width: 100%;
  font-size: 18px;
  line-height: 28px;
  font-weight: 500;
`;

const BoxBody = styled.div`
  margin-top: 20px;
`;

const SubBox = styled.div`
  margin-top: 16px;
  padding: 16px;
  background-color: rgb(248, 247, 249);
`;
const SubBoxTitle = styled.h3`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`;

const SpaceBox = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  background-color: transparent;
  padding: 8px 0px;
  min-width: 1px;
  width: 100%;
  flex: 1 1 0%;
  margin: 0px 8px;
  border-bottom: 1px solid rgb(221, 223, 226);
`

export default function OrderPage(props: any) {
    const history = useHistory();
    const [bookForSomeoneElse, setBookForSomeoneElse] = useState(false);

    const onFinish = (values: any) => {
        // console.log('Success:', values);
        history.push('/order/done');
    };

    const onValuesChange = (changedValues: any, allValues: any) => {
        setBookForSomeoneElse(allValues.bookForSomeoneElse);
    }

    return (
        <div className={'container-app app-order'}>
            <div className={'steps-order'}>
                <Steps current={1}>
                    <Step title="Chọn khách sạn"/>
                    <Step title="Thông tin của bạn"/>
                    <Step title="Hoàn tất đặt phòng"/>
                </Steps>
            </div>

            <div className={'order-info'}>
                <div className={'order-info-left'}>
                    <Box>
                        <div className={'login-container'}>
                            <img src="https://cdn6.agoda.net/images/desktop/login/illustration-deals-social.svg"
                                 className={'login-image'}/>
                            <div className={'login-info'}>
                                <div className={'login-info-text'}>
                                    <span className={'login-info-text-title'}>Không cần tự tay điền thông tin!</span>
                                    <a>Đăng nhập</a>
                                </div>
                                <p className={'login-info-desc'}>Đặt phòng Nhanh - Gọn - Lẹ! Hãy kết nối với Facebook
                                    hoặc đăng nhập vào tài khoản.</p></div>
                        </div>
                    </Box>
                    <Form layout={'horizontal'} onFinish={onFinish} onValuesChange={onValuesChange}>
                        <BoxWhite>
                            <BoxTitle>Vui lòng điền thông tin của bạn</BoxTitle>
                            <BoxBody>

                                <div className={'form-row'}>
                                    <label>Họ và tên như trong hộ chiếu</label>
                                    <Form.Item name={['name']}>
                                        <Input size={'large'} placeholder={''}/>
                                    </Form.Item>
                                </div>
                                <div className={'form-row'}>
                                    <label>Đia chỉ email</label>
                                    <Form.Item name={['name']}>
                                        <Input size={'large'} placeholder={''}/>
                                    </Form.Item>
                                </div>

                                <div className={'form-rows'}>
                                    <div className={'form-row'}>
                                        <label>Số điện thoại (không bắt buộc)</label>
                                        <Form.Item name={['name']}>
                                            <Input size={'large'} placeholder={''}/>
                                        </Form.Item>
                                    </div>
                                    <div className={'form-row'}>
                                        <label>Quốc gia cư trú</label>
                                        <Select size={'large'} style={{width: '100%'}}>
                                            <Option value="lucy">Lucy</Option>
                                        </Select>
                                    </div>
                                </div>

                                <div className={'form-row'}>
                                    <Form.Item name={['bookForSomeoneElse']} valuePropName="checked">
                                        <Checkbox>Tôi không ở phòng nào tại khách sạn này. Tôi đặt phòng giúp cho người
                                            khác.</Checkbox>
                                    </Form.Item>
                                </div>

                                {bookForSomeoneElse ? <SubBox>
                                    <SubBoxTitle>Thông tin khách hàng</SubBoxTitle>
                                    <BoxBody>
                                        <div className={'form-row'}>
                                            <label>Họ và tên như trong hộ chiếu</label>
                                            <Form.Item name={['name']}>
                                                <Input size={'large'} placeholder={''}/>
                                            </Form.Item>
                                        </div>
                                        <div className={'form-row'}>
                                            <label>Quốc gia cư trú</label>
                                            <Select size={'large'} style={{width: '100%'}}>
                                                <Option value="lucy">Lucy</Option>
                                            </Select>
                                        </div>
                                    </BoxBody>
                                </SubBox> : null}

                                <SubBoxTitle style={{marginTop: 20}}>Hãy cho chúng tôi biết quý khách cần
                                    gì</SubBoxTitle>
                                <div className={'form-row'}>
                                    <label>Chúng tôi sẽ báo cho khách sạn hoặc chủ nhà ngay sau khi bạn đặt
                                        phòng!</label>
                                    <Form.Item>
                                        <Input.TextArea showCount maxLength={100} rows={6}/>
                                    </Form.Item>
                                </div>

                            </BoxBody>
                        </BoxWhite>

                        <div className={'form-actions'}>
                            <p>Thực hiện bước tiếp theo đồng nghĩa với việc bạn chấp nhận tuân theo Điều khoản sử
                                dụng và Chính sách bảo mật của Agoda.</p>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" size={"large"}>Hoàn tất đặt phòng</Button>
                            </Form.Item>
                        </div>

                    </Form>
                </div>
                <div className={'order-info-right'}>
                    <BoxWhite>
                        <div className={'hotel-od-info'}>
                            <div className={'hotel-od-info-left'}>
                                <img
                                    src={'https://q-xx.bstatic.com/xdata/images/hotel/max500/230635211.jpg?k=c13a417048547e7a22086948871aa0e4d3113932ab326078285160a720fd1a3f&o='}/>
                            </div>
                            <div className={'hotel-od-info-right'}>
                                <h3>Cozrum Homes Lý Chính Thắng (Cozrum Homes Ly Chinh Thang)</h3>
                                <Rate character={<StarFilled/>} defaultValue={4} allowHalf
                                      style={{fontSize: 18, margin: 0}}/>
                                <p>7/7 Ly Chinh Thang, Ward 8, District 3, Hcmc, Quận 3, Hồ Chí Minh, Hồ Chí Minh, Việt
                                    Nam</p>
                            </div>
                        </div>
                    </BoxWhite>

                    <BoxWhite>
                        <BoxTitle>16 tháng 6 2021 - 30 tháng 6 2021</BoxTitle>
                        <div className="order-room">
                            <span className="order-room-title">4 x Căn hộ Studio (Studio Apartment)</span>
                            <span className="order-room-change">
                                <a>Đổi</a>
                            </span>
                        </div>
                        <div className='order-room-count'>
                            <div className='order-room-count-info-co'>
                                <div className='order-room-count-icon'>
                                    <svg style={{transform: 'scaleX(-1)'}} xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 24 24">
                                        <path
                                            d="M1.499 2.553h20.32a2 2 0 0 1 2 2v14.983a2 2 0 0 1-2 2H4.829a2 2 0 0 1-2-2V8.333L.298 4.951a1.5 1.5 0 0 1 1.2-2.398z"/>
                                    </svg>
                                    <div><span className='order-room-count-value'>8.5</span></div>
                                </div>
                                <div className='order-room-count-info'>
                                    <div className='order-room-count-container'><p
                                        className='order-room-count-view'>Sạch sẽ tuyệt
                                        vời</p></div>
                                    <div className='order-room-count-container-2'><p
                                        className='order-room-count-view-2'>Từ 133 bài đánh
                                        giá</p></div>
                                </div>
                            </div>
                        </div>
                        <SpaceBox/>
                        <div className={'row-if-order-room-user'}>
                            <div className={'row-if-order-room-user-icon'}>
                                <img
                                    src="data:image/svg+xml;base64,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"/>
                            </div>
                            <div className={'row-if-order-room-user-text'}>4 phòng, 8 người lớn</div>
                        </div>
                    </BoxWhite>

                    <BoxWhite>
                        <div className="price-section">
                            <div className="price-section-row">
                                <span className="price-section-text">Giá tiền&nbsp;(4 phòng x 14 đêm)</span>
                                <span className="price-section-value">40.448.272 ₫</span>
                            </div>
                            <div className="price-section-row">
                                <span className="price-section-text">Phí đặt trước</span>
                                <span className="price-section-free">MIỄN PHÍ</span>
                            </div>
                        </div>

                        <div className="PriceSection__totalPriceContainer">
                            <div className="TotalPrice__totalPrice">
                                <div><span className="TotalPrice__totalPriceLabel">Giá tiền</span>
                                    <div data-element-name="hotel-tax-and-service-fees">
                                        <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 24 24" className="sc-pBzUF bHYCoY">
                                            <path
                                                d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-.544 7.003a.5.5 0 0 1 1-.007l.077 10.015a.5.5 0 0 1-1 .007l-.077-10.015zm-.343-2.847a.844.844 0 1 1 1.687 0 .844.844 0 0 1-1.687 0z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="TotalPrice__totalPriceMoneyDisplay">
                                    <div className="TotalPrice__boldText">44.493.096 ₫</div>
                                </div>
                            </div>
                            <div className="PriceSection__charges">
                                <div className="ProcessedChargeSummary__charges">
                                    <span className="ChargeSummary__chargeText">
                                    <span className="ChargeSummary__processedChargeSummary">Giá đã bao gồm: </span>VAT 4.044.824 ₫</span>
                                </div>
                            </div>
                            <div className="SpeechBubble__speechBubble">
                                <span className="SpeechBubble__arrowUp SpeechBubble"/><span
                                className="WePriceMatch__wePriceMatchTextSpan"><span
                                className="WePriceMatch__boldText">Chúng tôi khớp giá.</span> Tìm được giá nào thấp hơn thì chúng tôi sẽ khớp giá đó!</span>
                            </div>
                            <div className="PriceSection__dottedTopContainer">
                                <div>Bạn sẽ thanh toán tại Cozrum Homes Lý Chính Thắng bằng ngoại tệ (₫).</div>
                            </div>
                        </div>
                    </BoxWhite>
                </div>
            </div>
        </div>
    )
}
